module.exports = __webpack_public_path__ + "img/img_supplier_xiaomi@2x.704f40bb.png";